<template>
  <div class="flex justify-center w-full h-auto">
    <div class="w-full max-w-3xl">
      <ExternalCreateTicket
        v-if="client"
        :client-document="client"
        :order-cod="order"
        :order-item-cod="orderItem"
        :workflow-id="workflowId"
        :organization="organization"
        :hash="hash"
        :type="type"
      />
    </div>

    <ExternalSnackbar
      :show="snackBar.show"
      @closed="snackBar.show = false"
    >
      {{ snackBar.message }}
    </ExternalSnackbar>
  </div>
</template>

<script>
import ExternalCreateTicket from '@/components/ExternalCreateTicket'
import ExternalSnackbar from '@/components/commons/ExternalSnackbar'
import { decrypt } from '@/repositories/integrations/mobly/services/csExternal/decrypt'
import { MOBLY } from '@/utils/possible-organizations-values'
import { setTheme } from '@/utils/theme'

export default {
  name: 'ExternalCreateTicketView',
  components: {
    ExternalCreateTicket,
    ExternalSnackbar
  },
  data () {
    return {
      client: null,
      order: null,
      orderItem: null,
      workflowId: null,
      organization: null,
      type: 'customer',
      snackBar: {
        show: false,
        message: ''
      },
      hash: null
    }
  },
  mounted () {
    this.setClient()
  },
  methods: {
    async setClient () {
      try {
        const decrypted = await this.decrypt()
        if ('document' in decrypted) {
          this.client = decrypted.document
        }

        if ('order' in decrypted) {
          this.order = decrypted.order
        }

        if ('orderItem' in decrypted) {
          this.orderItem = decrypted.orderItem
        }

        if ('workflowId' in decrypted) {
          this.workflowId = decrypted.workflowId
        }

        this.organization = decrypted.organization || MOBLY
        this.type = decrypted.type || 'customer'
        setTheme(this.organization)
      } catch (err) {
        this.snackBar.message = 'Não foi possível abrir a página requisitada.'
        this.snackBar.show = true
      }
    },

    async decrypt () {
      const hash = this.$route.query.h
      this.hash = encodeURIComponent(hash)
      const organization = this.$route.query.org
      const request =
        await decrypt({ hash }, organization)

      const decrypted = request.data

      return decrypted
    }
  }
}
</script>
